import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  useEntry,
  useDispatchEntryForm,
  useActionsEntry,
} from "../../../../context/inventory/EntryFormProvider";
import React from "react";
import "./observation.css";
import { types } from "../../../../reducers/inventory/entryReducer";
import Moment from "react-moment";
import "moment-timezone";
import { FORMAT_TIME, STATUS_EXCUTED } from "../../../../api/constant";
const Observations = () => {
  const state = useEntry();
  const dispatch = useDispatchEntryForm();
  const actions = useActionsEntry();
  const {
    entry: { observation },
  } = state;
  const { status_id } = state.entry;
  const { text, observations } = observation;
  return (
    <section className="container-fluid">
      {status_id !== STATUS_EXCUTED && (
        <div className="input-observation-entry w-100 flex">
          <textarea
            value={text}
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_OBSERVATION,
                payload: { name: e.target.name, value: e.target.value },
              })
            }
            placeholder="observaciones"
            className="flex1 font2"
            name="text"
          ></textarea>
          &nbsp;
          <div className=" flex-column justify-end">
            {text.length !== 0 && (
              <FontAwesomeIcon
                onClick={() => actions.addObservation()}
                className="blue flex cursor-pointer icon-plus"
                icon={faPlusSquare}
              />
            )}
          </div>
        </div>
      )}

      {observations.map((ob) => {
        return (
          <div key={ob.id} className="comment-entry">
            <span className="font1">
              <Moment format={FORMAT_TIME}>{ob.created_at}</Moment> - {ob.user}:
            </span>
            &nbsp;<span>{ob.note}</span>
          </div>
        );
      })}
    </section>
  );
};

export default Observations;
